import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { debounceTime, switchMap } from 'rxjs';
import { ProformaRepository } from 'src/app/proforma/domain/proforma.repository';
import { puertoRequest, requestTransportista, requestejecutivo } from 'src/app/proforma/domain/request/proforma_request';
import { ListIncoter, listaejecutivos } from 'src/app/proforma/domain/response/proforma_response';
import { ReportesRepository } from 'src/app/repositorio/reportes.repository';
// import { ReportesRepository } from 'src/app/reporte-ventas/domain/reportes.repository';
// import { FiltrosMultiSelect, ReporteVentasIRequest } from 'src/app/reporte-ventas/domain/request/reporte-ventas-request';
import { UtilService } from 'src/app/services/util.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { FiltrosMultiSelect, ReporteVentasIRequest } from '../../domain/reporte-ventas.request';

@Component({
    selector: 'app-reporte-seguimiento-cliente',
    standalone: true,
    imports: [
        CommonModule,
        SharedModule,
        MatAutocompleteModule,
        MatExpansionModule
    ],
    templateUrl: './reporte-seguimiento-cliente.component.html',
    styleUrl: './reporte-seguimiento-cliente.component.css'
})
export class ReporteSeguimientoClienteComponent {

  constructor(
    private readonly proforma: ProformaRepository,
    private readonly reportes: ReportesRepository,
    private readonly util: UtilService
  ) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.inicializarFormulario()
    this.listarejecutivo()
    this.cargaTodosTransportista()
    this.GenerarReporteSeguimientoCliente()
  }

  group: FormGroup
  group2: FormGroup
  inicializarFormulario() {

    this.group = new FormGroup({
      desde: new FormControl(new Date(new Date().getFullYear(), new Date().getMonth(), 1), null),
      hasta: new FormControl(new Date(), null),
      ejecutivo: new FormControl(null, null),
      cliente: new FormControl([], null),
      pod: new FormControl([], null),
      pol: new FormControl([], null),
      etd: new FormControl([], null),
      bkg: new FormControl([], null),
      ov: new FormControl([], null),
      service: new FormControl([], null),
      nave: new FormControl([], null),
      ejecutivos: new FormControl([], null),
      linea: new FormControl([], null),
    })

    this.group2 = new FormGroup({
      desde: new FormControl(new Date(new Date().getFullYear(), 0, 1), null),
      hasta: new FormControl(new Date(), null),
      ejecutivo: new FormControl([], null),
      pod: new FormControl([], null),
      pol: new FormControl([], null),
      cliente: new FormControl([], null),
      linea: new FormControl([], null),
      service: new FormControl([], null),
      etd: new FormControl(null, null),
    })
  }

  //FROMULARIO GROUP 2 - SEGUIMIENTO DE CLIENTE
  Group2Codigos: any[] = [{ pod: 0, pol: 0, linea: 0, cliente: 0 }]
  limpiar(value, form) {

    if (form == 'group2') {
      this.group2.get(value).reset()
      this.Group2Codigos[value] = 0

    }
  }


  Group2ListaPuertosOrigen: any[] = []
  Group2PuertoOrigen(): void {
    const request = <puertoRequest>{
      pchrCONS_CodVia: '001',
      pchrCONS_TabVia: 'VIA',
      pchrPUER_CodEstandar: '',
      pintPUER_Codigo: '',
      pvchPUER_Nombre: ''
    };

    this.group2.get('pod').valueChanges.pipe(
      debounceTime(300), // Añade debounce para evitar demasiadas solicitudes
      switchMap(value => this.proforma.listarPuerto({ ...request, pvchPUER_Nombre: value }))
    ).subscribe(response => {
      this.Group2ListaPuertosOrigen = response.datos.result.map(r => ({
        nombre: r.pueR_Nombre,
        codigo: r.pueR_Codigo
      }));
    });
  }

  Group2OrigenSeleccionado(event: MatAutocompleteSelectedEvent) {
    const selectedOption = this.Group2ListaPuertosOrigen.find(option => option.nombre.toLowerCase() === event.option.value.toLowerCase());
    if (selectedOption) {
      this.Group2Codigos['pod'] = selectedOption.codigo
    }
  }

  Group2ListaPuertosDestino: any[] = []
  Group2PuertoDestino() {
    const request = <puertoRequest>{
      pchrCONS_CodVia: '001',
      pchrCONS_TabVia: 'VIA',
      pchrPUER_CodEstandar: '',
      pintPUER_Codigo: '',
      pvchPUER_Nombre: ''
    };

    this.group2.get('pol').valueChanges.pipe(
      debounceTime(300), // Añade debounce para evitar demasiadas solicitudes
      switchMap(value => this.proforma.listarPuerto({ ...request, pvchPUER_Nombre: value }))
    ).subscribe(response => {
      this.Group2ListaPuertosDestino = response.datos.result.map(r => ({
        nombre: r.pueR_Nombre,
        codigo: r.pueR_Codigo
      }));
    });
  }

  Group2DestinoSeleccionado(event: MatAutocompleteSelectedEvent) {
    const selectedOption = this.Group2ListaPuertosDestino.find(option => option.nombre.toLowerCase() === event.option.value.toLowerCase());

    if (selectedOption) {
      this.Group2Codigos['pol'] = selectedOption.codigo
    }
  }


  ListaPolsGroup2: any[] = []
  ListaPodsGroup2: any[] = []
  ListaLineasGroup2: any[] = []
  ListaServicesGroup2: any[] = []
  ListaClientesGroup2: any[] = []
  mesesArray = [];
  dataReporteSeguimientoCliente: any = []
  GenerarReporteSeguimientoCliente() {
    console.log("Buscando GenerarReporteSeguimientoCliente")
    const values = this.group2.value
    this.mesesArray = []
    this.dataReporteSeguimientoCliente = []

    const Ejecutivos: FiltrosMultiSelect[] = []
    const Clientes: FiltrosMultiSelect[] = []
    const Services: FiltrosMultiSelect[] = []
    const Pods: FiltrosMultiSelect[] = []
    const Pols: FiltrosMultiSelect[] = []

    const Lineas: FiltrosMultiSelect[] = []
    const Etds: FiltrosMultiSelect[] = []


    console.log("VALORES: ", values)

    values.ejecutivo.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = r
      items.filt_codigovar = ''
      items.filt_nombre = ''
      Ejecutivos.push(items)
    })



    values.cliente.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = r
      Clientes.push(items)
    })

    if (values.pol && values.pol != null && values.pol != '') {

      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = this.Group2Codigos['pol']
      items.filt_codigovar = ''
      items.filt_nombre = values.pol
      Pols.push(items)

    }

    if (values.pod && values.pod != null && values.pod != '') {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = values.pod
      Pods.push(items)

    }

    //Daniel
    if (values.service && values.service != null && values.service != '') {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = values.service
      Services.push(items)

    }

    values.linea.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = r
      Lineas.push(items)
    })

    if (values.etd && values.etd != null && values.etd != '') {
      const date = new Date(values.etd); // Convertimos el string ISO 8601 a objeto Date
      const formattedDate = date.toISOString().split('T')[0]; // Obtenemos la parte de la fecha YYYY-MM-DD

      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = formattedDate; // Asignamos la fecha formateada
      Etds.push(items)
    }

    const request = <ReporteVentasIRequest>{}
    request.ejecutivo = Ejecutivos
    request.mes = 0
    request.cliente = Clientes
    request.pol = Pols
    request.etd = Etds//DAniel3.0
    request.linea = Lineas //DANIEL 2.0
    request.bkg = []
    request.servcontract = Services
    request.ov = []
    request.nave = []
    request.pod = Pods
    request.tipo = '002'
    request.desde = values.desde !== null ? values.desde : ''
    request.hasta = values.hasta !== null ? values.hasta : ''

    const mesinicio = new Date(values.desde);
    const mesfin = new Date(values.hasta);



    // Iterar sobre cada mes entre mesinicio y mesfin
    for (let date = new Date(mesinicio); date <= mesfin; date.setMonth(date.getMonth() + 1)) {
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Obtener el mes en formato de dos dígitos
      this.mesesArray.push(month); // Agregar el mes al array
    }

    this.reportes.ListaReporteVentasII(request).subscribe(response => {
      this.dataReporteSeguimientoCliente = response.datos.result


      response.datos.result.forEach(r => {

        if (r.cliente != '' && r.cliente != null) {
          const existe = this.ListaClientesGroup2.some(item => item.nombre === r.cliente);

          if (!existe) {
            const items = { nombre: r.cliente };
            this.ListaClientesGroup2.push(items);
            //this.ListaClientesGroup2.sort((a, b) => a.nombre.localeCompare(b.nombre));

          }
        }

        this.FilterClientesGroup2 = this.ListaClientesGroup2
      })

    }, (errorServicio) => {
      this.util.ShowMessage({ mensaje: errorServicio.error.meta.mensaje, tipo: 'warning' })
    })
  }




  getTotalCost(columnName: string, arr: any): string {
    let total = 0
    if (arr != undefined) {
      const columnData = (arr.map(row => this.parseNumber(row[columnName] == null ? '0' : row[columnName].toString())));
      total = columnData.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    }

    if (columnName == 'porcentaje') {
      return (total).toFixed(0);
    } else {
      return total.toLocaleString('es-PE');
    }

  }

  parseNumber(numberString: string): number {
    let sanitizedString
    if (numberString != null) {
      const formattedString = numberString.replace(',', '&');
      sanitizedString = formattedString.replace('&', '');
    }
    return parseFloat(sanitizedString);
  }

  onDateChange(event: any, campo: string, formulario: string) {
    const selectedDate = event.value;
    selectedDate.setHours(0, 0, 0, 0);

    // if (formulario == 'group') {
    //   this.group.get(campo).setValue(selectedDate.toISOString());
    // } else
    if (formulario == 'group2') {
      this.group2.get(campo).setValue(selectedDate.toISOString());
    }
  }

  limpiarControl(group: string, control: string) {
    if (group == "group2") {
      this.group2.get(control).reset([])
    }
    this.GenerarReporteSeguimientoCliente()
  }
  toppingList: any[] = []
  selectAllIfAllSelected() {
    const selectedOptions = this.group.value.ejecutivos;
    if (selectedOptions.includes('')) {
      this.group.get('ejecutivos').setValue([...this.toppingList.map(t => t.codigo)]);
    }
  }

  selectAllSelected(group: string, campo: string) {

    if (group == 'group2') {
      const selectedOptions = this.group2.value[campo];
      if (selectedOptions.includes('')) {
        this.group2.get(campo).setValue([...this.ListaEjecutivosGroup2.map(t => t.codigo)]);
      }
    }

  }

  ListaEjecutivosGroup2: any[] = []
  listadoejecutivo: listaejecutivos[]
  requestEjecutivo: requestejecutivo
  listarejecutivo() {
    this.requestEjecutivo = <requestejecutivo>{}
    this.requestEjecutivo.entc_Codigo = 3

    this.proforma.listarejecutivo(this.requestEjecutivo).subscribe((response) => {
      if (response.datos.status === 200) {
        this.listadoejecutivo = response.datos.result;

        // Limpiar y reiniciar la lista

        // this.ListaEjecutivosGroup2 = [];

        // Agregar el item 'TODOS'
        const items = { codigo: '', nombre: 'TODOS' }
        this.toppingList.push(items);
        this.ListaEjecutivosGroup2.push(items);

        // Mapear y agregar ejecutivos a ListaEjecutivosGroup2 usando 'items'
        response.datos.result.forEach(r => {
          const items = { codigo: r.codejecutivo, nombre: r.nombreejecutivo }
          this.toppingList.push(items);
          this.ListaEjecutivosGroup2.push(items);
        });

        // Ordenar ListaEjecutivosGroup2 alfabéticamente por nombre
        this.ListaEjecutivosGroup2.sort((a, b) => a.nombre.localeCompare(b.nombre));
        this.toppingList.sort((a, b) => a.nombre.localeCompare(b.nombre));
      }
      this.FilterEjecutivosGroup2 = this.ListaEjecutivosGroup2;
    });
  }



  getSelectedEjecutivosNames2() {
    const selectedEjecutivos = this.group2.value.ejecutivo;
    if (!selectedEjecutivos || selectedEjecutivos.length === 0) {
      return '';
    }

    const primerCodigo = selectedEjecutivos[0]; // Obtener el primer código seleccionado

    const primerEjecutivo = this.ListaEjecutivosGroup2.find(e => e.codigo === primerCodigo);
    return primerEjecutivo ? primerEjecutivo.nombre : '';
  }

  textoFiltroAgente: string = '';
  listaTodosTransportistas: any = []
  cargaTodosTransportista() {
    const request: requestTransportista = <requestTransportista>{}

    request.pintENTC_Codigo = 1;
    request.pintENTC_Razonsocial = "";
    this.proforma.listaTransportista(request).subscribe(response => {
      for (let i = 0; i < response.datos.result.length; i++) {
        const item: ListIncoter = {
          nombre: response.datos.result[i].descripcionTransportista,
          codigo: response.datos.result[i].codigoTransportista.toString(),
        }
        this.listaTodosTransportistas.push(item);
        this.listaTodosTransportistas.sort((a, b) => a.nombre.localeCompare(b.nombre));
      }
      this.FilterLineasGroup2 = this.listaTodosTransportistas
    });
  }

  FilterLineasGroup2 = this.listaTodosTransportistas
  FilterClientesGroup2 = this.ListaClientesGroup2
  FilterEjecutivosGroup2 = this.ListaEjecutivosGroup2
  applyFilters2(event: Event, tipo: string) {

    // if (tipo == 'service') {
    //   const inputElement = event.target as HTMLInputElement;
    //   const value = inputElement.value;
    //   this.filterValue = value.trim().toLowerCase();
    //   this.FilterServicesGroup = this.ListaServices.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
    // }

    if (tipo == 'cliente') {
      const inputElement = event.target as HTMLInputElement;
      const value = inputElement.value;
      const filtro = value.trim().toLowerCase();
      this.FilterClientesGroup2 = this.ListaClientesGroup2.filter(user => user.nombre.toLowerCase().includes(filtro));
    }

    if (tipo == 'linea') {
      const inputElement = event.target as HTMLInputElement;
      const value = inputElement.value;
      const filtro = value.trim().toLowerCase();
      this.FilterLineasGroup2 = this.listaTodosTransportistas.filter(user => user.nombre.toLowerCase().includes(filtro));
    }

    if (tipo == 'ejecutivo') {
      const inputElement = event.target as HTMLInputElement;
      const value = inputElement.value;
      const filtro = value.trim().toLowerCase();
      this.FilterEjecutivosGroup2 = this.ListaEjecutivosGroup2.filter(user => user.nombre.toLowerCase().includes(filtro));
    }

  }

  orderFieldName2: string = ''
  statusFieldName2: string = 'sort'
  countFieldName2: number = 0
  sortColumn2(fieldName: string) {

    if (fieldName == this.orderFieldName2 && this.statusFieldName2 == 'arrow_downward') {
      this.dataReporteSeguimientoCliente.sort((a, b) => { if (a[fieldName] > b[fieldName]) return -1; if (a[fieldName] < b[fieldName]) return 1; return 0 })
      this.statusFieldName2 = 'arrow_upward'
    } else {
      this.dataReporteSeguimientoCliente.sort((a, b) => { if (a[fieldName] < b[fieldName]) return -1; if (a[fieldName] > b[fieldName]) return 1; return 0 })
      this.statusFieldName2 = 'arrow_downward'
    }

    this.orderFieldName2 = fieldName
  }
}
